(function () {
  function initSlider() {
    const sliderElements = document.querySelectorAll(".js-products-slider");

    if (!sliderElements.length) return;

    sliderElements.forEach((sliderEl) => {
      const swiperWrapper = sliderEl.querySelector(
        ".popular-products__list--slider"
      );
      const slides = sliderEl.querySelectorAll(".popular-products__item");

      if (!swiperWrapper || !slides.length) return;

      syncProductEntranceAnimation(sliderEl, slides);

      const isAutoplayEnabled =
        swiperWrapper.dataset.autoplay &&
        swiperWrapper.dataset.autoplay.toLowerCase() === "true";
      const shouldPauseOnHover =
        isAutoplayEnabled && swiperWrapper.dataset.stopAutoplay === "true";

      sliderEl.dataset.headingGroupPauseOnHover = shouldPauseOnHover
        ? "true"
        : "false";

      if (sliderEl.dataset.headingGroupSliderInitialized === "true") {
        syncAutoplay(sliderEl.swiper, isAutoplayEnabled, swiperWrapper);
        syncAutoplayHover(sliderEl, shouldPauseOnHover);
        syncHoveredAutoplay(sliderEl);
        return;
      }
      sliderEl.dataset.headingGroupSliderInitialized = "true";

      const section = sliderEl.closest(".products-slider");
      if (!section) return;

      const productsPerRow = Number(sliderEl.dataset.productsPerRow || 4);
      const productsPerRowMobile = Number(
        sliderEl.dataset.productsPerRowMobile || 1
      );

      const slidesPerViewMobile = productsPerRowMobile;
      const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
      const slidesPerView990 =
        productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
      const slidesPerView1360 = productsPerRow >= 4 ? 4 : productsPerRow;
      const slidesPerView1600 = productsPerRow;

      let previousProgress = 0;

      const sliderSettings = {
        speed: 800,
        slidesPerView: slidesPerViewMobile,

        allowTouchMove: false,
        mousewheel: {
          enabled: false,
          forceToAxis: true,
          sensitivity: 0.5,
          thresholdDelta: 30,
          thresholdTime: 300,
          releaseOnEdges: true,
        },

        pagination: {
          el: section.querySelector(
            ".heading-group-slider__navigation .swiper-pagination"
          ),
          type: "progressbar",
        },

        navigation: {
          nextEl: section.querySelector(
            ".heading-group-slider__navigation-button-next"
          ),
          prevEl: section.querySelector(
            ".heading-group-slider__navigation-button-prev"
          ),
          disabledClass: "swiper-button-disabled",
        },

        breakpoints: {
          576: { slidesPerView: slidesPerView576 },
          990: { slidesPerView: slidesPerView990 },
          1360: { slidesPerView: slidesPerView1360 },
          1600: { slidesPerView: slidesPerView1600 },
        },

        on: {
          progress(swiper, progress) {
            if (
              sliderEl.dataset.isCreativeEffect &&
              sliderEl.dataset.isCreativeEffect.toLowerCase() === "true"
            ) {
              const direction =
                swiper.progress > previousProgress ? "next" : "prev";
              previousProgress = swiper.progress;
              const delay = swiper.params.speed / 64;
              const visibleIndexes = swiper.visibleSlidesIndexes;
              const firstIndex = visibleIndexes[0];
              const lastIndex = visibleIndexes[visibleIndexes.length - 1];

              const setDelay = (slideEl, slideIndex) => {
                if (direction === "next" && slideIndex >= firstIndex) {
                  slideEl.style.transitionDelay = `${
                    (slideIndex - firstIndex + 1) * delay
                  }ms`;
                } else if (
                  direction === "prev" &&
                  slideIndex <= lastIndex + 1
                ) {
                  slideEl.style.transitionDelay = `${
                    (lastIndex - slideIndex + 1) * delay
                  }ms`;
                } else {
                  slideEl.style.transitionDelay = `${0}ms`;
                }
              };

              swiper.slides.forEach((slideEl, slideIndex) => {
                if (swiper.animating) {
                  slideEl.style.transitionDelay = "0ms";
                  requestAnimationFrame(() => {
                    setDelay(slideEl, slideIndex);
                  });
                } else {
                  setDelay(slideEl, slideIndex);
                }
              });
            }
          },
          init(swiper) {
            updateNavigation(swiper);
          },
          resize(swiper) {
            updateNavigation(swiper);
          },
        },
      };

      if (isAutoplayEnabled) {
        sliderSettings.autoplay = {
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        };
      }

      if (
        sliderEl.dataset.isCreativeEffect &&
        sliderEl.dataset.isCreativeEffect.toLowerCase() === "true"
      ) {
        const isRTL = sliderEl.dir === "rtl" || document.dir === "rtl";
        const offset = isRTL ? 100.5 : -100.5;

        sliderSettings.effect = "creative";
        sliderSettings.creativeEffect = {
          limitProgress: 100,
          prev: {
            translate: [`${offset}%`, 0, 0],
          },
          next: {
            translate: [`${-offset}%`, 0, 0],
          },
        };
      } else {
        sliderSettings.spaceBetween = 2;
      }

      new Swiper(sliderEl, sliderSettings);
      syncAutoplayHover(sliderEl, shouldPauseOnHover);
      syncHoveredAutoplay(sliderEl);

      const btn = section.querySelector(".toggle-heading-slider-btn");

      if (!btn) return;

      const headingGroup = btn.closest(".heading-group-slider");
      const wrapper = headingGroup.querySelector(
        ".heading-group-slider__details"
      );

      if (!btn || !wrapper) return;

      const dots = btn.querySelectorAll(".dot");

      function playAnimation(direction) {
        btn.style.animation = "none";
        btn.offsetHeight;
        btn.style.animation = "";
        btn.style.animationDirection = direction;
        btn.style.animationPlayState = "running";

        dots.forEach((dot) => {
          dot.style.animation = "none";
          dot.offsetHeight;
          dot.style.animation = "";
          dot.style.animationDirection = direction;
          dot.style.animationPlayState = "running";
        });
      }

      let isHovered = false;
      let closedByClick = false;
      let mousedownOnBtn = false;

      function openMenu() {
        btn.classList.add("active");
        wrapper.classList.remove("close");
        wrapper.classList.add("open");
      }

      function closeMenu() {
        btn.classList.remove("active");
        wrapper.classList.remove("open");
        wrapper.classList.add("close");
      }

      btn.addEventListener("mousedown", () => {
        mousedownOnBtn = true;
        setTimeout(() => {
          mousedownOnBtn = false;
        }, 0);
      });

      btn.addEventListener("click", () => {
        if (btn.classList.contains("active")) {
          closedByClick = true;
          isHovered = false;
          playAnimation("reverse");
          closeMenu();
          btn.blur();
        } else {
          if (!wrapper.classList.contains("open")) {
            openMenu();
          }

          if (!isHovered) {
            playAnimation("normal");
          }
        }
      });

      btn.addEventListener("focus", (e) => {
        if (mousedownOnBtn) {
          return;
        }

        if (!btn.classList.contains("active")) {
          if (!isHovered) {
            closedByClick = false;
            playAnimation("normal");
          }
          openMenu();
        }
      });

      btn.addEventListener("blur", () => {
        if (btn.classList.contains("active")) {
          closedByClick = true;
          isHovered = false;
          playAnimation("reverse");
          closeMenu();
        }
      });

      btn.addEventListener("mouseenter", () => {
        isHovered = true;
        closedByClick = false;

        if (!btn.classList.contains("active")) {
          playAnimation("normal");
        }
      });

      btn.addEventListener("mouseleave", () => {
        isHovered = false;

        if (closedByClick) {
          closedByClick = false;
          return;
        }

        if (!btn.classList.contains("active")) {
          playAnimation("reverse");
        }
      });
    });
  }

  function syncProductEntranceAnimation(sliderEl, slides) {
    const section = sliderEl.closest(".products-slider");
    const isAnimationEnabled =
      section?.dataset.enableAnimation &&
      section.dataset.enableAnimation.toLowerCase() === "true";

    slides.forEach((el) => {
      if (el.dataset.iGlobal != null) {
        el.style.setProperty("--i-global", el.dataset.iGlobal);
      }

      if (el.dataset.iLocal != null) {
        el.style.setProperty("--i-local", el.dataset.iLocal);
      }

      if (!isAnimationEnabled) {
        el.classList.remove("in-view");
      }
    });

    if (!isAnimationEnabled || sliderEl.dataset.productEntranceObserved) {
      return;
    }

    sliderEl.dataset.productEntranceObserved = "true";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    slides.forEach((item) => {
      observer.observe(item);
    });
  }

  function syncAutoplay(swiper, isAutoplayEnabled, swiperWrapper) {
    if (!swiper || !swiper.params) return;

    if (!isAutoplayEnabled) {
      if (swiper.autoplay) {
        swiper.autoplay.stop();
      }
      swiper.params.autoplay = false;
      return;
    }

    const autoplaySettings = {
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    };

    swiper.params.autoplay = autoplaySettings;

    if (swiper.autoplay) {
      swiper.autoplay.start();
    }
  }

  function syncAutoplayHover(sliderEl, shouldPauseOnHover) {
    if (!sliderEl) return;

    if (!window.headingGroupSliderAutoplayHoverHandlers) {
      window.headingGroupSliderAutoplayHoverHandlers = new WeakMap();
    }

    const handlers = window.headingGroupSliderAutoplayHoverHandlers;
    const previousHandlers = handlers.get(sliderEl);

    if (previousHandlers) {
      sliderEl.removeEventListener("pointerenter", previousHandlers.pause);
      sliderEl.removeEventListener("pointerleave", previousHandlers.resume);
      handlers.delete(sliderEl);
    }

    if (!shouldPauseOnHover) return;

    const pause = () => {
      sliderEl.dataset.headingGroupAutoplayHovered = "true";
      pauseAutoplay(sliderEl.swiper);
    };
    const resume = () => {
      sliderEl.dataset.headingGroupAutoplayHovered = "false";
      resumeAutoplay(sliderEl.swiper);
    };

    sliderEl.addEventListener("pointerenter", pause);
    sliderEl.addEventListener("pointerleave", resume);
    handlers.set(sliderEl, { pause, resume });
  }

  function syncHoveredAutoplay(sliderEl) {
    if (
      sliderEl.dataset.headingGroupPauseOnHover === "true" &&
      sliderEl.dataset.headingGroupAutoplayHovered === "true"
    ) {
      pauseAutoplay(sliderEl.swiper);
    }
  }

  function pauseAutoplay(swiper) {
    if (!swiper?.autoplay || !swiper.params.autoplay) return;

    if (typeof swiper.autoplay.stop === "function") {
      swiper.autoplay.stop();
    }
  }

  function resumeAutoplay(swiper) {
    if (!swiper?.autoplay || !swiper.params.autoplay) return;

    if (typeof swiper.autoplay.start === "function") {
      swiper.autoplay.start();
    }
  }

  function updateNavigation(swiper) {
    if (!swiper) return;

    const windowWidth = window.innerWidth;
    const shouldAllowTouch = windowWidth < 1160;

    swiper.allowTouchMove = shouldAllowTouch;
    swiper.update();

    if (swiper.isLocked) {
      swiper.mousewheel.disable();
    } else {
      swiper.mousewheel.enable();
    }
  }

  document.addEventListener("DOMContentLoaded", initSlider);
  document.addEventListener("shopify:section:load", initSlider);
  document.addEventListener("heading-slider:load", initSlider);
})();
